import { createReducer, createAction } from 'utils/reducer';

export const GET_STATE_FROM_API = 'users/GET_STATE_FROM_API';
export const GET_STATE_FROM_API_SUCCESS = 'users/GET_STATE_FROM_API_SUCCESS';
export const CREATE_USER = 'users/CREATE_USER';
export const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'users/CREATE_USER_FAIL';
export const UPDATE_USER = 'users/UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'users/UPDATE_USER_FAIL';
export const DELETE_USER = 'users/DELETE_USER';
export const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'users/DELETE_USER_FAIL';

export const USERS = {
  GET_STATE_FROM_API,
  GET_STATE_FROM_API_SUCCESS,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
};

export const usersActions = {
  getStateFromApi: createAction(GET_STATE_FROM_API),
  createUser: createAction(CREATE_USER, 'formData'),
  updateUser: createAction(UPDATE_USER, 'userId', 'formData'),
  deleteUser: createAction(DELETE_USER, 'userId'),
};

const initialState = {
  formIsOpen: false,
  users: {},
  createUserLoading: false,
  createUserError: null,
  updateUserLoading: false,
  updateUserError: null,
  deleteUserLoading: false,
  deleteUserError: null,
};

const users = createReducer(initialState, {
  [GET_STATE_FROM_API]: (state) => {},
  [GET_STATE_FROM_API_SUCCESS]: (state, action) => {
    if (action.payload && action.payload.users) {
      const normalizedUsers = {};
      action.payload.users.forEach((user) => {
        normalizedUsers[user.id] = user;
      });

      state.users = normalizedUsers;
    }
  },

  [CREATE_USER]: (state) => {
    state.createUserLoading = true;
    state.createUserError = null;
  },
  [CREATE_USER_SUCCESS]: (state, action) => {
    state.createUserLoading = false;
    state.createUserError = null;

    if (action.payload && action.payload.user) {
      const newUser = action.payload.user;
      state.users[newUser.id] = newUser;
    }
  },
  [CREATE_USER_FAIL]: (state, action) => {
    state.createUserLoading = false;
    state.createUserError = action.payload?.error || 'Error desconocido';
  },
  [UPDATE_USER]: (state) => {
    state.updateUserLoading = true;
    state.updateUserError = null;
  },

  [UPDATE_USER_SUCCESS]: (state, action) => {
    state.updateUserLoading = false;
    state.updateUserError = null;

    if (action.payload && action.payload.user) {
      const updatedUser = action.payload.user;
      state.users[updatedUser.id] = updatedUser;
    }
  },

  [UPDATE_USER_FAIL]: (state, action) => {
    state.updateUserLoading = false;
    state.updateUserError = action.payload?.error || 'Error desconocido al actualizar usuario';
  },
  [DELETE_USER]: (state) => {
    state.deleteUserLoading = true;
    state.deleteUserError = null;
  },

  [DELETE_USER_SUCCESS]: (state, action) => {
    state.deleteUserLoading = false;
    state.deleteUserError = null;

    const userId = action.payload?.userId;
    if (userId && state.users[userId]) {
      delete state.users[userId];
    } else {
      console.warn('⚠️ No se pudo eliminar el usuario, userId no encontrado:', userId);
    }
  },

  [DELETE_USER_FAIL]: (state, action) => {
    state.deleteUserLoading = false;
    state.deleteUserError = action.payload?.error || 'Error desconocido al eliminar usuario';
  },
});

export default users;
